import { Checkbox } from 'antd';
import * as React from 'react';

interface CheckboxFieldProps {
  showLabel?: string;
  label?: string;
  options?: any[];
  onChanged?: (any) => any;
}

const CheckboxField: React.FC<CheckboxFieldProps | any> = ({
  // options = [],
  // TODO:mostra la label della checkbox
  showLabel = false,
  ...props
}) => {
  // const [OPTIONS, setOPTIONS] = React.useState(options)

  // React.useEffect(() => {
  // 	if (props.checked) {
  // 		props.defaultValue = props.checked
  // 	}
  // }, [props])

  if (!props.options) {
    return (
      <Checkbox {...props} nostyle={true}>
        {showLabel ? props.label || 'Si' : ''}
      </Checkbox>
    );
  }

  return (
    <Checkbox.Group
      {...props}
      // options={OPTIONS}
      defaultValue={props?.checked || []}
      style={{
        width: '100%',
      }}
    />
  );
};

export default CheckboxField;
